import classNames from 'classnames'
import { extendTailwindMerge } from 'tailwind-merge'

const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['xxs'] }],
    },
  },
})

export const cn = (...inputs: classNames.ArgumentArray) =>
  customTwMerge(classNames(inputs))
